import { configureStore } from "@reduxjs/toolkit";
import shuteReducer from "../../shared/atoll/redux/shuteSlice";
import authReducer from "../../shared/atoll/redux/authSlice";
import authDebugReducer from "../../shared/atoll/redux/authDebugSlice";
import consoleReducer from "../../shared/atoll/redux/consoleSlice";
import prefsReducer from "../../shared/atoll/redux/prefsSlice";
import bugattiReducer from "./bugattiSlice";
import sputnikapiresponseReducer from "./sputnikapiresponseSlice"
import nebulonspreadReducer from "./nebulonSpreadSlice"
import systemserviceReducer from "./systemserviceSlice"
import tuyascenesReducer from "./tuyaScenesSlice"
import dimensionsReducer from "@rhino/shared/services/redux/dimensionsSlice"
import { combinedMiddleware } from "../../shared/atoll/redux/shuteCallbackRegistry";

export const store = configureStore({
  reducer: {
    shute: shuteReducer,
    auth: authReducer,
    authDebug: authDebugReducer,
    console: consoleReducer,
    prefs: prefsReducer,
    bugatti: bugattiReducer,
    sputnikapiresponse: sputnikapiresponseReducer,
    systemservices: systemserviceReducer,
    nebulonspread: nebulonspreadReducer,
    tuyascenes: tuyascenesReducer,
    dimensions: dimensionsReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(combinedMiddleware),

});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


